<template>
    <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="values" @submit.prevent>
        <div class="row pt-2 ps-5 pe-5 pt-4">
            <div class="col-sm-5 pe-6">
                <section>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Şəxsi məlumat</p>
                    <br />
                    <el-form-item>
                        <partner-finder :propvalue="values.insured" @change-value="value => values.insured = value"
                            :insType="'p'" :onlyP="true" />
                    </el-form-item>
                    <div class="row">
                        <div class="col-sm-6">
                            <el-form-item label="Boy">
                                <el-input type="number" v-model="values.insured.height" />
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="Çəki">
                                <el-input type="number" v-model="values.insured.weight" />
                            </el-form-item>
                        </div>
                    </div>
                </section>


                <br />

                <!-- Faydalanan -->
                <el-checkbox v-model="values.isBenInsured" label="Faydalanan sığortalıdır" />
                <section>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Faydalanan</p>
                    <br />
                    <el-form-item>
                        <partner-finder :disabled="values.isBenInsured" :propvalue="values.beneficiary" :insType="'p'"
                            @change-value="value => values.beneficiary = value" />
                    </el-form-item>
                </section>
            </div>

            <div class="col-sm-2"></div>

            <!-- Right side -->
            <div class="col-sm-5 ps-3">
                <!-- Məbləğ -->
                <section>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Məbləğ</p>

                    <br />

                    <div class="row">
                        <div class="col-sm-6">
                            <el-form-item label="Bank vergi dərəcəsi">
                                <el-input type="number" v-model="values.bankTax" />
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="Risk məbləğ">
                                <el-input type="number" v-model="values.riskSum" />
                            </el-form-item>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <el-form-item label="Sığorta məbləği">
                                <el-input type="number" v-model="values.sumInsured" />
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="Sığorta haqqı">
                                <el-input type="number" v-model="values.premium" />
                            </el-form-item>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <el-form-item label="Beta cost">
                                <el-input type="number" v-model="values.betaCost" />
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="Sığorta məbləğ limiti">
                                <el-input type="number" v-model="values.sumLimit" />
                            </el-form-item>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <el-form-item label="Ödəyici haqqı" label-position="top">
                                <el-input type="number" v-model="values.holderPremium" class="w-100" />
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="Ödəyici məbləği" label-position="top">
                                <el-input type="number" v-model="values.holderSumInsured" class="w-100" />
                            </el-form-item>
                        </div>
                    </div>
                </section>

                <br />

                <section>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Deposit</p>
                    <br />
                    <el-form-item label="Depozit nömrə">
                        <el-select v-model="values.depId">
                            <el-option label="AZ76AZRT35090039440004920001-6.00" value="1" />
                            <el-option label="AZ76AZRT35090039440004920001-7.00" value="2" />
                            <el-option label="AZ76AZRT35090039440004920001-5.00" value="3" />
                            <el-option label="AZ76AZRT35090039440004920001-7.00" value="4" />
                            <el-option label="AZ76AZRT35090039440004920001-8.00" value="5" />
                        </el-select>
                    </el-form-item>

                    <div class="row">
                        <div class="col-sm-6">
                            <el-form-item label="Depozit dərəcəsi">
                                <el-input type="number" v-model="values.depRate" />
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="Klient depozit dərəcəsi">
                                <el-input type="number" v-model="values.depRateClient" />
                            </el-form-item>
                        </div>
                    </div>
                </section>
                <br />
                <section>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Əlavə risklər</p>
                    <br />
                    <el-form-item>
                        <el-checkbox v-model="values.addCover" label="Şikəstlik" />
                    </el-form-item>
                    <div class="row" v-if="values.addCover">
                        <div class="col-sm-6">
                            <el-form-item label="III dərəcə (%)">
                                <el-input type="number" v-model="values.coverDegree3" />
                            </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="II dərəcə (%)">
                                <el-input type="number" v-model="values.coverDegree2" />
                            </el-form-item>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div class="row pt-2 ps-5 pe-5">
            <div class="table-responsive">
                <p class="font-weight-bold p-header p-2 w-100 lead mb-3">Sığorta olunanın çəkilmiş xəstəliklərə
                    tutulması
                </p>
                <el-table size="large" border :data="this.data" class="el-table-css" style="width: 100%">
                    <el-table-column type="selection" align="center" width="55" />
                    <el-table-column prop="descr" />
                </el-table>
                <p class="font-weight-bold p-header mt-4 p-2 w-100 lead mb-3">
                    Sığorta olunanda sadalanan xəstəliklər və ya simptomlar mövcuddur
                </p>
                <el-table border size="large" :data="this.data2" class="el-table-css" style="width: 100%">
                    <el-table-column type="selection" align="center" width="55" />
                    <el-table-column prop="descr" />
                </el-table>
            </div>
        </div>
        <br>
        <!-- Footer buttons -->
        <el-affix position="bottom" :offset="5">
            <div class="pe-5" style="background-color: white; display: flex; justify-content: end;">
                <soft-button @click="SubmitForm" color="success">
                    {{ !editing ? "Daxil et" : "Qəbul et" }}
                </soft-button>
                <!-- &nbsp;&nbsp;&nbsp;
                <soft-button @click="editing ? $emit('close-dialog') : $router.push('/cancel')" color="secondary">
                    İmtina
                </soft-button> -->
            </div>
        </el-affix>
    </el-form>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import PartnerFinder from "@/project/Components/PartnerFinder.vue";

export default {
    components: {
        SoftButton,
        PartnerFinder,
    },
    props: {
        object: Object,
        editing: Boolean,
        insert: Boolean,
    },
    data() {
        return {
            values: { insured: { height: null, weight: null } },
              data: [
                {
                    check: true,
                    descr: "Siz tibbi müayinədən keçmisiniz (zəhmət olmasa tarixi qeyd edərdiniz)? Hər hansı kənarlaşmalar müəyyən edilibmi?"
                },
                {
                    descr: "Siz dərman preparatları qəbul edirsinizmi? Əgər cavab müsbətdirsə, dərmanın adını qeyd edərdiniz."
                },
                {
                    descr: "Siz pivə, çaxır və spirtli içkilər qəbul edirsinizmi? Əgər cavab müsbətdirsə, onda gün ərzində qəbul edilən içkilərin sayını göstərin."
                },
                { 
                    descr: "Sizin sənətiniz təhlükəli qiymətləndirilən əmək fəaliyyəti və ya məşğuliyyətlə (idman...) bağlıdırmı? Məsələn: aviasiya və ya avtomobil yarışları?"
                },
                { 
                    descr: "Sizin hər hansı xroniki xəstəliyiniz (diabet, ürək-damar, tənəffüs, mədə-bağırsaq və s.) varmı?"
                },
                { 
                    descr: "Siz son 5 il ərzində əməliyyat və ya hospitalizasiya olunmusunuzmu?"
                },
                { 
                    descr: "Sizdə allergiyalar (dərman, qida, toz, polen və s.) varmı?"
                },
                { 
                    descr: "Siz narkotik vasitələr qəbul etmisinizmi və ya hazırda qəbul edirsinizmi?"
                }
            ],
            data2: [
                { 
                    descr: "Ürəyin işemik xəstəliyi."
                },
                { 
                    descr: "Yüksək qan təzyiqi."
                },
                {
                    descr: "Şəkərli diabet."
                },
                {
                    descr: "Astma."
                },
                {
                    descr: "Qaraciyər xəstəlikləri (hepatit, sirroz)."
                },
                {
                    descr: "Beyin insultu və ya sinir sistemi xəstəlikləri."
                }
            ],
            rules: {
                period: [
                    { required: true, message: "Mütləq sahə", trigger: "blur" },
                    { type: "number", min: 36, message: "Minimum 36 ay", trigger: "blur" },
                ],
            },
        };
    },
    mounted() {
        if (this.editing) {
            this.values = { ...this.object };
        }
    },
    methods: {
        SubmitForm() {
            this.$refs.ruleFormRef.validate((valid) => {
                if (valid) {
                    window.location.href =
                        window.location.origin + "/documents/quota/" + 3;
                }
            });
        },
    },
};
</script>
